import { Platform, Pressable, StyleSheet, View } from 'react-native';
import { useState } from 'react';

import { Text } from '@/components/ui';
import { useTheme } from '@/theme';

export type FaqItem = { q: string; a: string };

export function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [open, setOpen] = useState<number | null>(0);
  const theme = useTheme();

  return (
    <View style={{ borderTopWidth: 1, borderTopColor: theme.colors.rule }}>
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <View key={it.q + i} style={[styles.item, { borderBottomColor: theme.colors.rule }]}>
            <Pressable
              accessibilityRole="button"
              onPress={() => setOpen(isOpen ? null : i)}
              style={({ hovered }: any) => [
                styles.row,
                Platform.OS === 'web' && hovered ? { opacity: 0.85 } : null,
              ]}
            >
              <Text variant="h4" style={{ flex: 1 }}>
                {it.q}
              </Text>
              <Text
                style={{
                  fontFamily: theme.fontFamily.mono,
                  fontSize: 18,
                  color: theme.colors.fgSoft,
                  transform: [{ rotate: isOpen ? '45deg' : '0deg' }],
                }}
              >
                +
              </Text>
            </Pressable>
            {isOpen ? (
              <View style={styles.answer}>
                <Text variant="body" tone="fgSoft" style={{ maxWidth: 640 }}>
                  {it.a}
                </Text>
              </View>
            ) : null}
          </View>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  item: {
    borderBottomWidth: 1,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 24,
    gap: 16,
  },
  answer: {
    paddingBottom: 24,
  },
});
